import { useState } from 'react';
import { displayDuration, roundIntsOnly } from '../../utils/parsing';
import InlineTextEdit from './InlineTextEdit';
import ListSelector from './ListSelector';

import './duration-selector.css';

const UNITS = {
  minutes: 60,
  hours: 60 * 60,
  days: 60 * 60 * 24,
};

const toSeconds = (val, inUnit) => {
  const multiplier = UNITS[inUnit];
  return multiplier * val;
};
const toUnit = (valSeconds, newUnit) => {
  const multiplier = UNITS[newUnit];
  return valSeconds / multiplier;
};

export { toSeconds, toUnit };

/**
 * A controlled duration selector that operates on values in seconds
 */
const DurationSelector = ({ label, seconds, onSecondsChange }) => {
  const { unit: defaultUnit } = displayDuration(seconds, 'seconds');
  const [unit, setUnit] = useState(defaultUnit);
  const displayValue = roundIntsOnly(toUnit(seconds, unit).toFixed(2));
  return (
    <>
      <InlineTextEdit
        label={label}
        value={displayValue}
        type="number"
        inputProps={{ min: 1 }}
        onValueChange={(v) => onSecondsChange(toSeconds(v, unit))}
        fullWidth={false}
      />
      <ListSelector
        className="duration-unit-sel"
        values={Object.keys(UNITS)}
        selected={unit}
        onChange={setUnit}
      />
    </>
  );
};

export default DurationSelector;
